/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { configureStore } from '@reduxjs/toolkit';
import login from './loginSlice';

export const store = configureStore({ reducer: { login } });
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
